import {PanoramaIcon} from 'lib/ui/Icon'
import styled from 'styled-components'

const PositionSelectorButton = styled(PanoramaIcon)`
  cursor: pointer;
  font-size: 25px;
`

export default PositionSelectorButton
